// src/components/projectDetails/ProjectBrief.js

import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import {
  Grid,
  Typography,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
  CircularProgress,
  Skeleton,
  Divider,
  Card,
  CardContent,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useParams, useNavigate } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { useAuth } from "../../context/AuthProvider";
import { Doughnut } from "react-chartjs-2";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
// import mySvg from '../../img/v-curve-athrv-img.svg'
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { IconButton } from "@mui/material";
import { toast } from "react-toastify";
import ai from "../../img/ai-generative-white.svg";
import { v4 as uuidv4 } from "uuid";
const ProjectBrief = ({ project }) => {
  const { projectId } = useParams();
  const { authToken, organizationId } = useAuth();
  const [runDetails, setRunDetails] = useState([]);
  const [healthDetails, setHealthDetails] = useState([]);
  const [loc, setLoc] = useState(null);
  const printableRef = useRef();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [projectLoading, setProjectLoading] = useState(true);
  const [error, setError] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [analysisResult, setAnalysisResult] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const newRunId = useRef(uuidv4());
  const [isDownloading, setIsDownloading] = useState(false); // State for download button loading
  const [isfetching, setIsFetching] = useState(false);
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isStacked = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const isDarkMode = theme.palette.mode === "dark";
  const token = localStorage.getItem("access_token");
  const OrgType = localStorage.getItem("org_type");
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });

  const {
    name,
    description,
    codeLanguage,
    createdAt,
    mainFileName,
    clientRepoUrl,
    is_limit_exceeded,
    latestConfig,
    clocReport,
    sourceFilesAndSubDirectories,
  } = project;

  const renderRow = (title, value) => (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap", // allows the whole row to wrap
        alignItems: "flex-start",
        mb: 3,
      }}
    >
      <Typography
        variant="subtitle1"
        color="textSecondary"
        sx={{
          fontWeight: 500,
          minWidth: "120px",
          wordBreak: "break-word",
          overflowWrap: "break-word",
          mr: 1,
          fontSize: { xs: "0.9rem", sm: "1rem", md: "1.1rem" },
        }}
      >
        {title}
      </Typography>

      <Box
        sx={{
          flex: 1,
          wordBreak: "break-word",
          overflowWrap: "break-word",
        }}
      >
        {typeof value === "string" || typeof value === "number" ? (
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: "0.9rem", sm: "1rem", md: "1.1rem" },
            }}
          >
            {value || "N/A"}
          </Typography>
        ) : (
          value || "N/A"
        )}
      </Box>
    </Box>
  );

  const renderCommaSeparated = (items) =>
    items && items.length
      ? items.map((item) => item.toolName).join(", ")
      : "N/A";
  const fetchProjectDetails = useCallback(async () => {
    setProjectLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/platform/projects/run-details?project_id=${projectId}`,
        // `${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/platform/project_and_all_its_run_details/${projectId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch project details");
      }
      const data = await response.json();
      console.log(data);
      let locValue = null;

      const clocReportError = data?.project?.clocReport?.error;
      if (
        clocReportError &&
        clocReportError.toLowerCase().includes("repository")
      ) {
        locValue = "No Access";
      } else if (data?.project?.clocReport?.SUM?.code !== undefined) {
        locValue = data.project.clocReport.SUM.code;
      }
      const sortedRunDetails = data.sort((a, b) => b.createdAt - a.createdAt);
      setRunDetails(sortedRunDetails);
      setLoc(locValue);
    } catch (error) {
      console.error("Error fetching project details:", error);
      setError(true);
    } finally {
      setProjectLoading(false);
    }
  }, [projectId, token]);
  const fetchProjectHealthDetails = useCallback(async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/platform/reports/project_health_details?project_id=${projectId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch project health details");
      }
      const data = await response.json();
      setHealthDetails(data);
    } catch (error) {
      console.error("Error fetching project health details:", error);
    }
  }, [projectId, token]);

  //Displaying all File with LOC
  const handleNavigateToLOCDetails = () => {
    setClicked(true);
    navigate(`/projects/${projectId}/loc-details`);
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sortedData = [...runDetails].sort((a, b) => {
      if (key === "createdAt") {
        return direction === "asc"
          ? a.createdAt - b.createdAt
          : b.createdAt - a.createdAt;
      } else if (key === "runStatus") {
        return direction === "asc"
          ? a.runStatus.localeCompare(b.runStatus)
          : b.runStatus.localeCompare(a.runStatus);
      }
      return 0;
    });

    setRunDetails(sortedData);
  };

  useEffect(() => {
    fetchProjectDetails();
    fetchProjectHealthDetails();
  }, [fetchProjectDetails, fetchProjectHealthDetails]);

  const exportToPDF = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const chartCanvas = printableRef.current;

    // Add Title
    doc.setFontSize(16);
    doc.text("Project Brief Report", 10, 10);

    // Add Text Content
    doc.setFontSize(12);
    doc.text("Project Name: Example Project", 10, 20);
    doc.text("Description: This is a sample project description.", 10, 30);
    doc.text("Code Language: JavaScript", 10, 40);

    // // Export Chart as Image and Add to PDF
    // if (chartCanvas) {
    //   const chartDataUrl = chartCanvas.toBase64Image('image/png', 1.0); // High resolution
    //   doc.addImage(chartDataUrl, 'PNG', 10, 50, 100, 100); // Adjust position and size
    // }

    // Save the PDF
    doc.save("ProjectBriefReport.pdf");
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const scrollRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  const checkScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft + clientWidth < scrollWidth);
    }
  };

  useEffect(() => {
    checkScroll();
    const handleResize = () => checkScroll();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -200 : 200,
        behavior: "smooth",
      });
    }
  };

  // // Quality Evolution Data
  // const qualityMetrics = [
  //   { title: 'Issues', value: '15%', color: '#FFEB3B' }, // Light Yellow
  //   { title: 'Complexity', value: '0%', color: '#8BC34A' }, // Light Green
  //   { title: 'Duplication', value: '4%', color: '#8BC34A' }, // Light Green
  //   { title: 'Coverage', value: '23%', color: '#F44336' }, // Red
  // ];

  // // Dummy data for code health metrics
  // const codeHealthData = {
  //   labels: ['Maintainability', 'Reliability', 'Security'],
  //   datasets: [
  //     {
  //       data: [65, 20, 15], // Replace with real-world data later
  //       backgroundColor: ['#4caf50', '#ff9800', '#f44336'],
  //       hoverBackgroundColor: ['#66bb6a', '#ffb74d', '#ef5350'],
  //     },
  //   ],
  // };

  const handleDownloadPDF = async () => {
    try {
      setIsDownloading(true);

      const apiUrl = `${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/platform/reports/latest-consolidated-report?project_id=${projectId}`;

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch report information");
      }

      const data = await response.json();
      console.log("API Response:", data);

      if (data && data.presigned_url) {
        const link = document.createElement("a");
        link.href = data.presigned_url;
        link.download = `consolidated_Report_${projectId}.pdf`;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        alert("PDF generation failed. No presigned URL found.");
        console.error("Presigned URL missing in API response:", data);
      }
    } catch (error) {
      console.error("Error during download:", error);
      alert("Failed to download the report. Please try again later.");
    } finally {
      setIsDownloading(false);
    }
  };
  const handleAIAnalysis = async () => {
    try {
      setIsFetching(true);

      const requestBody = {
        project_id: projectId,
        organization_id: organizationId,
        jwt_access_token: token,
        service_mode: "ai-pre-analysis",
      };

      const apiUrl = `${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/platform/ai-agent/pre-analysis`;
      const analysisResponse = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!analysisResponse.ok) {
        throw new Error("Failed to fetch analysis report");
      }
      const analysisData = await analysisResponse.json();
      if (analysisData.notification_message) {
        toast.info(analysisData.notification_message);
      }
      navigate(`/projects/${projectId}`, {
        state: { activeTab: 1 },
      });
      //  pollAnalysisStatus();
    } catch (error) {
      console.error("AI analysis failed:", error);
    } finally {
      setIsFetching(false);
    }
  };
  const handleRunClick = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    console.log("context org id : " + organizationId);
    const apiUrl = `${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/platform/run`;
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          project_id: projectId,
          run_id: newRunId.current,
          organization_id: organizationId,
          jwt_access_token: token,
        }),
      });
      const data = await response.json();
      // ✅ Show toast if notification_message exists
      if (data.notification_message) {
        toast.info(data.notification_message);
      }
      if (response.ok && data.success == true) {
        navigate(`/pipeline/${newRunId.current}`);
      } else {
        console.error("Failed to make the POST request");
        setIsSubmitting(false);
      }
    } catch (error) {
      setIsSubmitting(false);
      console.error("Error during the POST request", error);
    }
  };

  const handleEditClick = () => navigate(`/projects/${projectId}/edit`);
  const handleDeleteClick = async () => {
    if (window.confirm("Confirm Delete Project?")) {
      await fetch(
        `${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/platform/projects/${projectId}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      navigate("/projects");
    }
  };

  if (
    !project ||
    !healthDetails.quality_metrics ||
    !healthDetails.code_health_data
  ) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
        }}
      >
        <Typography variant="h6" color="textSecondary">
          Loading project details...
        </Typography>
      </Box>
    );
  }

  return (
    <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
      <Grid
        container
        spacing={2}
        sx={{
          alignItems: "stretch",
          flexDirection: {
            xs: "column", // <600px
            sm: "column", // 600px+
            md: "column", // 900px+
            lg: "row", // 1024px+
          },
        }}
      >
        {/* Left Grid - Project Details */}
        <Grid item xs={12} lg={8} sx={{ width: "100%" }}>
          <Paper
            elevation={3}
            sx={{
              p: { xs: 2, sm: 3 },
              height: "100%",
            }}
          >
            <div ref={printableRef}>
              {renderRow(
                "Project Name:",
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: "1rem", sm: "1.1rem", md: "1.2rem" },
                    fontWeight: 500,
                    wordBreak: "break-word",
                  }}
                >
                  {name}
                </Typography>
              )}
              {renderRow("Code Language:", codeLanguage)}
              {renderRow("Description:", description)}
              {renderRow(
                "Created At:",
                createdAt ? new Date(createdAt * 1000).toLocaleString() : "N/A"
              )}
              {renderRow(
                "Main File:",
                <Typography sx={{ wordBreak: "break-word" }}>
                  {mainFileName}
                </Typography>
              )}

              {clientRepoUrl &&
                renderRow(
                  "Repository URL:",
                  <a
                    href={clientRepoUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: "none",
                      color: "#1976d2",
                      fontWeight: 500,
                      wordBreak: "break-word",
                      fontSize: "1rem",
                    }}
                  >
                    {clientRepoUrl.length > 35
                      ? `${clientRepoUrl
                          .replace("https://github.com/", "")
                          .replace(".git", "")}`
                      : clientRepoUrl}
                  </a>
                )}

              {clocReport &&
                renderRow(
                  "Lines Of Code:",
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    {/* If clocReport?.SUM?.code is null or undefined, show loader */}
                    {clocReport?.SUM?.code == null ? (
                      <CircularProgress size={20} sx={{ mr: 1, mb: 1 }} />
                    ) : (
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: { xs: "0.9rem", sm: "1rem", md: "1.1rem" },
                          mr: 2,
                        }}
                      >
                        {(clocReport.SUM.code / 1000).toFixed(3)}k
                      </Typography>
                    )}

                    <Typography
                      variant="body1"
                      color="primary"
                      sx={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        color: isDarkMode ? "#006699" : "inherit",
                        fontSize: { xs: "0.9rem", sm: "1rem", md: "1.1rem" },
                      }}
                      onClick={handleNavigateToLOCDetails}
                    >
                      See Details
                    </Typography>
                    <IconButton
                      onClick={handleNavigateToLOCDetails}
                      color="primary"
                      sx={{
                        color: isDarkMode ? "#006699" : "inherit",
                        "&:hover": { color: "white" },
                        ml: 1,
                      }}
                    >
                      <ArrowForwardIcon fontSize="small" />
                    </IconButton>
                    {typeof is_limit_exceeded !== "undefined" &&
                      is_limit_exceeded && (
                        <Typography
                          variant="body2"
                          sx={{
                            border: "1px solid #ccc",
                            backgroundColor: "#fff3cd",
                            borderRadius: "8px",
                            color: "#856404",
                            fontWeight: 500,
                            ml: 1,
                            px: 1.5,
                            py: 0.5,
                            fontSize: {
                              xs: "0.8rem",
                              sm: "0.9rem",
                              md: "1rem",
                            },
                          }}
                        >
                          Code limit has been exceeded.
                        </Typography>
                      )}
                  </Box>
                )}
            </div>
          </Paper>
        </Grid>
        {/* Right Grid - Buttons and Image */}
        <Grid item xs={12} lg={4} sx={{ width: "100%" }}>
          <Paper
            elevation={3}
            sx={{
              p: { xs: 2, sm: 3 },
              height: "100%",
            }}
          >
            {/* Buttons - responsive layout */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                mb: 3,
              }}
            >
              <Button
                variant="contained"
                color="primary"
                disabled={isSubmitting}
                onClick={handleRunClick}
                sx={{
                  borderRadius: 2,
                  width: "100%",
                  height: 60,
                  backgroundColor: "#202A44",
                }}
              >
                {isSubmitting ? (
                  <CircularProgress size={24} sx={{ color: "lightgray" }} />
                ) : (
                  "RUN"
                )}
              </Button>
              <Button
                variant="contained"
                onClick={handleAIAnalysis}
                disabled={isfetching}
                sx={{
                  height: 60,
                  width: "100%",
                  fontSize: { xs: "0.9rem", sm: "1rem" },
                  textTransform: "none",
                  borderRadius: 2,
                  background:
                    theme.palette.mode === "dark"
                      ? "linear-gradient(90deg, #1976d2 0%, #2196f3 100%)"
                      : "linear-gradient(90deg, #1976d2 0%, #2196f3 100%)",
                  color: "#fff",
                  boxShadow: "0 4px 14px rgba(0,0,0,0.2)",
                  "&:hover": {
                    background:
                      theme.palette.mode === "dark"
                        ? "linear-gradient(90deg, #1565c0 0%, #1e88e5 100%)"
                        : "linear-gradient(90deg, #1565c0 0%, #1e88e5 100%)",
                  },
                }}
              >
                {isfetching ? (
                  <CircularProgress size={20} sx={{ color: "#fff" }} />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 1,
                    }}
                  >
                    <img src={ai} alt="AI" style={{ height: "28px" }} />
                    ANALYSIS
                  </Box>
                )}
              </Button>

              <Button
                variant="contained"
                onClick={handleDownloadPDF}
                disabled={isDownloading}
                sx={{
                  height: 60,
                  width: "100%",
                  fontSize: { xs: "0.85rem", sm: "0.95rem" },
                  textTransform: "none",
                  borderRadius: 2,
                  background:
                    theme.palette.mode === "dark"
                      ? "linear-gradient(90deg, #43a047 0%, #66bb6a 100%)"
                      : "linear-gradient(90deg, #43a047 0%, #66bb6a 100%)",
                  color: "#fff",
                  boxShadow: "0 4px 14px rgba(0,0,0,0.2)",
                  "&:hover": {
                    background:
                      theme.palette.mode === "dark"
                        ? "linear-gradient(90deg, #388e3c 0%, #43a047 100%)"
                        : "linear-gradient(90deg, #388e3c 0%, #43a047 100%)",
                  },
                }}
              >
                {isDownloading ? (
                  <CircularProgress size={20} sx={{ color: "#fff" }} />
                ) : (
                  "Download Consolidated Report"
                )}
              </Button>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleEditClick}
                  sx={{
                    height: 50,
                    width: "170px",
                    fontSize: { xs: "0.85rem", sm: "0.95rem" },
                    textTransform: "none",
                    borderRadius: 2,
                    background:
                      theme.palette.mode === "dark" ? "#14213D" : "#14213D",
                    color: "#fff",
                    boxShadow: "0 4px 14px rgba(0,0,0,0.2)",
                    "&:hover": {
                      background:
                        theme.palette.mode === "dark" ? "#14213D" : "#14213D",
                    },
                  }}
                >
                  Edit
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleDeleteClick}
                  sx={{
                    height: 50,
                    width: "170px",
                    fontSize: { xs: "0.85rem", sm: "0.95rem" },
                    textTransform: "none",
                    borderRadius: 2,
                    background:
                      theme.palette.mode === "dark" ? "#FF0000" : "#FF0000",
                    color: "#fff",
                    boxShadow: "0 4px 14px rgba(0,0,0,0.2)",
                    "&:hover": {
                      background:
                        theme.palette.mode === "dark" ? "#FF0000" : "#FF0000",
                    },
                  }}
                >
                  Delete
                </Button>
              </Box>
            </Box>

            {/* Image */}
            {/* <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                mt: 2,
              }}
            >
              <object
                type="image/svg+xml"
                data="/img/v-curve-athrv-img.svg"
                aria-label="Project Image"
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "400px",
                  maxWidth: "100%",
                }}
              />
            </Box> */}
          </Paper>
        </Grid>
      </Grid>

      {/* Code Health and Quality Evolution Section */}

      {healthDetails && (
        <Box mt={4}>
          <Card elevation={2} sx={{ borderRadius: 2, p: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
              Overall Code Health
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={3}>
              {/* Datasets */}
              <Grid item xs={12} md={12}>
                <Grid container spacing={2}>
                  {healthDetails.code_health_data.datasets[0].data.map(
                    (value, index) => {
                      const formattedLabel =
                        healthDetails.code_health_data.labels[index]
                          .replace(/[^a-zA-Z0-9 ]/g, "")
                          .replace(/\b\w/g, (char) => char.toUpperCase());

                      return (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                          <Card
                            elevation={2}
                            sx={{
                              p: 2,
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                              justifyContent: "center",
                              borderRadius: 2,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                mb: 1,
                              }}
                            >
                              <Box
                                sx={{
                                  width: 10,
                                  height: 10,
                                  borderRadius: "50%",
                                  backgroundColor:
                                    healthDetails.code_health_data.datasets[0]
                                      .backgroundColor[index],
                                  mr: 1,
                                }}
                              />
                              <Typography
                                variant="subtitle1"
                                color="textSecondary"
                              >
                                {formattedLabel}
                              </Typography>
                            </Box>
                            <Typography
                              variant="h5"
                              sx={(theme) => ({
                                fontWeight: "bold",
                                color:
                                  theme.palette.mode === "dark"
                                    ? "#ffffff"
                                    : "#424242",
                              })}
                            >
                              {value}
                            </Typography>
                          </Card>
                        </Grid>
                      );
                    }
                  )}
                </Grid>
              </Grid>

              {/* Quality Metrics */}
              <Grid item xs={12} md={12}>
                <Grid container spacing={2}>
                  {healthDetails.quality_metrics.map((metric, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                      <Card
                        elevation={2}
                        sx={{
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          justifyContent: "center",
                          borderRadius: 2,
                        }}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", mb: 1 }}
                        >
                          <Box
                            sx={{
                              width: 10,
                              height: 10,
                              borderRadius: "50%",
                              backgroundColor: metric.color,
                              mr: 1,
                            }}
                          />
                          <Typography variant="subtitle1" color="textSecondary">
                            {metric.title}
                          </Typography>
                        </Box>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: "bold",
                            color:
                              theme.palette.mode === "dark"
                                ? "#ffffff"
                                : "#424242",
                          }}
                        >
                          {String(metric.value).replace("%", " %")}
                        </Typography>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Box>
      )}

      <Grid>
        <Grid item xs={12} md={4}>
          <Box mt={5}>
            <Card elevation={2} sx={{ borderRadius: 2, p: 3 }}>
              <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                Latest Configuration
              </Typography>
              <Divider sx={{ mb: 2 }} />
              {(() => {
                const buildToolName =
                  OrgType === "O"
                    ? latestConfig.buildTool?.toolName
                    : latestConfig.buildTool?.GenerictoolName;

                return buildToolName && buildToolName !== "N/A"
                  ? renderRow("Build Tool:", buildToolName)
                  : null;
              })()}
              {(() => {
                const tools =
                  OrgType === "O"
                    ? latestConfig.staticAnalysisTools
                    : latestConfig.staticAnalysisTools;
                const rendered = renderCommaSeparated(tools);
                return rendered && rendered !== "N/A"
                  ? renderRow("Static Analysis Tools:", rendered)
                  : null;
              })()}
              {(() => {
                const tools =
                  OrgType === "O"
                    ? latestConfig.unitTestingTools
                    : latestConfig.unitTestingTools;
                const rendered = renderCommaSeparated(tools);
                return rendered && rendered !== "N/A"
                  ? renderRow("Unit Testing Tools:", rendered)
                  : null;
              })()}
              {(() => {
                const tools =
                  OrgType === "O"
                    ? latestConfig.memoryTestingTools
                    : latestConfig.memoryTestingTools;
                const rendered = renderCommaSeparated(tools);
                return rendered && rendered !== "N/A"
                  ? renderRow("Memory Testing Tools:", rendered)
                  : null;
              })()}

              {(() => {
                const tools =
                  OrgType === "O"
                    ? latestConfig.cybersecurityAnalysisTools
                    : latestConfig.cybersecurityAnalysisTools;
                const rendered = renderCommaSeparated(tools);
                return rendered && rendered !== "N/A"
                  ? renderRow("Cyber Security Analysis Tools:", rendered)
                  : null;
              })()}
            </Card>
          </Box>
        </Grid>
        <Grid item xs={12} md={5}>
          <Box mt={4} textAlign="right">
            {/* <Button
              variant="contained"
              className="athrv-dash-primary-button"
              onClick={handleDownloadPDF}
              // onClick={exportToPDF}
              // onClick={handlePrint}
              // onClick={() => printableRef.current.generatePDF()}
            >
              Download Consolidated PDF Report
            </Button> */}
            {/* Hidden printable content */}
            {/* <div style={{ display: 'none' }}>
              <PrintableContent
                ref={printableRef}
                projectDetails={project}
              />
            </div> */}
          </Box>
        </Grid>
      </Grid>

      <Paper sx={{ p: 3 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Typography variant="h6" sx={{ mr: 2 }}>
            Run History
          </Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
            {showLeftArrow && (
              <IconButton
                onClick={() => scroll("left")}
                sx={{ background: "#fff" }}
              >
                <ChevronLeft />
              </IconButton>
            )}
            {showRightArrow && (
              <IconButton
                onClick={() => scroll("right")}
                sx={{ background: "#fff" }}
              >
                <ChevronRight />
              </IconButton>
            )}
          </Box>
        </Box>

        {projectLoading ? (
          <CircularProgress />
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box sx={{ position: "relative" }}>
                {/* Scrollable Table */}
                <Box
                  ref={scrollRef}
                  onScroll={checkScroll}
                  sx={{
                    overflowX: "auto",
                    width: "100%",
                  }}
                >
                  <TableContainer component={Paper} sx={{ minWidth: "900px" }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            onClick={() => handleSort("createdAt")}
                            sx={{ cursor: "pointer", whiteSpace: "nowrap" }}
                          >
                            Created At{" "}
                            {sortConfig.key === "createdAt" &&
                              (sortConfig.direction === "asc" ? "▲" : "▼")}
                          </TableCell>
                          <TableCell
                            onClick={() => handleSort("runStatus")}
                            sx={{ cursor: "pointer", whiteSpace: "nowrap" }}
                          >
                            Run Status{" "}
                            {sortConfig.key === "runStatus" &&
                              (sortConfig.direction === "asc" ? "▲" : "▼")}
                          </TableCell>
                          <TableCell sx={{ whiteSpace: "nowrap" }}>
                            Build Status
                          </TableCell>
                          <TableCell sx={{ whiteSpace: "nowrap" }}>
                            Static Analysis
                          </TableCell>
                          <TableCell sx={{ whiteSpace: "nowrap" }}>
                            Memory Testing
                          </TableCell>
                          <TableCell sx={{ whiteSpace: "nowrap" }}>
                            Unit Testing
                          </TableCell>
                          <TableCell sx={{ whiteSpace: "nowrap" }}>
                            Cyber Testing
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(
                          runDetails.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          ) || []
                        ).map((run) => (
                          <TableRow
                            key={run.run_id}
                            hover
                            onClick={() =>
                              navigate(`/rundetails/${run.run_id}`)
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <TableCell>
                              {new Date(run.createdAt * 1000).toLocaleString()}
                            </TableCell>
                            <TableCell>{run.runStatus}</TableCell>
                            <TableCell>
                              {run.runDetails?.build?.buildStatus || "N/A"}
                            </TableCell>
                            <TableCell>
                              {run.runDetails?.staticAnalysis?.length > 0 ? (
                                run.runDetails.staticAnalysis.map(
                                  (analysis, index) => (
                                    <Accordion
                                      key={index}
                                      sx={{
                                        borderBottom: "1px solid #cfcbcb",
                                      }}
                                    >
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls={`panel-${run.run_id}-content`}
                                        id={`panel-${run.run_id}-header`}
                                        onClick={(event) =>
                                          event.stopPropagation()
                                        }
                                      >
                                        <Typography variant="subtitle2">
                                          {analysis.toolName}
                                        </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails
                                        sx={{ alignItems: "center" }}
                                      >
                                        <Typography variant="body2">
                                          Status: {analysis.analysisStatus}
                                        </Typography>
                                        <Box
                                          sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          <Tooltip
                                            title={
                                              analysis.analysisError || "None"
                                            }
                                            placement="top"
                                            arrow
                                          >
                                            <Typography
                                              variant="body2"
                                              sx={{
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                maxWidth: "22vw",
                                              }}
                                            >
                                              Error:{" "}
                                              {analysis.analysisError || "None"}
                                            </Typography>
                                          </Tooltip>
                                        </Box>
                                        <Typography variant="body2">
                                          Time: {analysis.analysisTime || "N/A"}
                                        </Typography>
                                      </AccordionDetails>
                                    </Accordion>
                                  )
                                )
                              ) : (
                                <Typography>No Analysis</Typography>
                              )}
                            </TableCell>
                            <TableCell>
                              {run.runDetails?.memoryTesting?.length > 0 ? (
                                run.runDetails.memoryTesting.map(
                                  (analysis, index) => (
                                    <Accordion
                                      key={index}
                                      sx={{
                                        borderBottom: "1px solid #cfcbcb",
                                      }}
                                    >
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls={`panel-${run.run_id}-content`}
                                        id={`panel-${run.run_id}-header`}
                                        onClick={(event) =>
                                          event.stopPropagation()
                                        }
                                      >
                                        <Typography variant="subtitle2">
                                          {analysis.toolName}
                                        </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails
                                        sx={{ alignItems: "center" }}
                                      >
                                        <Typography variant="body2">
                                          Status: {analysis.memoryTestStatus}
                                        </Typography>
                                        <Box
                                          sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          <Tooltip
                                            title={
                                              analysis.memoryTestError || "None"
                                            }
                                            placement="top"
                                            arrow
                                          >
                                            <Typography
                                              variant="body2"
                                              sx={{
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                maxWidth: "22vw",
                                              }}
                                            >
                                              Error:{" "}
                                              {analysis.memoryTestError ||
                                                "None"}
                                            </Typography>
                                          </Tooltip>
                                        </Box>
                                        <Typography variant="body2">
                                          Time:{" "}
                                          {analysis.memoryTestTime || "N/A"}
                                        </Typography>
                                      </AccordionDetails>
                                    </Accordion>
                                  )
                                )
                              ) : (
                                <Typography>No Analysis</Typography>
                              )}
                            </TableCell>
                            <TableCell>
                              {run.runDetails?.unitTesting?.length > 0 ? (
                                run.runDetails.unitTesting.map(
                                  (analysis, index) => (
                                    <Accordion
                                      key={index}
                                      sx={{
                                        borderBottom: "1px solid #cfcbcb",
                                      }}
                                    >
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls={`panel-${run.run_id}-content`}
                                        id={`panel-${run.run_id}-header`}
                                        onClick={(event) =>
                                          event.stopPropagation()
                                        }
                                      >
                                        <Typography variant="subtitle2">
                                          {analysis.toolName}
                                        </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails
                                        sx={{ alignItems: "center" }}
                                      >
                                        <Typography variant="body2">
                                          Status: {analysis.testStatus}
                                        </Typography>
                                        <Box
                                          sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          <Tooltip
                                            title={analysis.testError || "None"}
                                            placement="top"
                                            arrow
                                          >
                                            <Typography
                                              variant="body2"
                                              sx={{
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                maxWidth: "22vw",
                                              }}
                                            >
                                              Error:{" "}
                                              {analysis.testError || "None"}
                                            </Typography>
                                          </Tooltip>
                                        </Box>
                                        <Typography variant="body2">
                                          Time: {analysis.testTime || "N/A"}
                                        </Typography>
                                      </AccordionDetails>
                                    </Accordion>
                                  )
                                )
                              ) : (
                                <Typography>No Analysis</Typography>
                              )}
                            </TableCell>
                            <TableCell>
                              {run.runDetails?.cybersecurityAnalysis?.length >
                              0 ? (
                                run.runDetails.cybersecurityAnalysis.map(
                                  (analysis, index) => (
                                    <Accordion
                                      key={index}
                                      sx={{
                                        borderBottom: "1px solid #cfcbcb",
                                      }}
                                    >
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls={`panel-${run.run_id}-content`}
                                        id={`panel-${run.run_id}-header`}
                                        onClick={(event) =>
                                          event.stopPropagation()
                                        }
                                      >
                                        <Typography variant="subtitle2">
                                          {analysis.toolName}
                                        </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails
                                        sx={{ alignItems: "center" }}
                                      >
                                        <Typography variant="body2">
                                          Status:{" "}
                                          {analysis.cybersecurityAnalysisStatus}
                                        </Typography>
                                        <Box
                                          sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          <Tooltip
                                            title={
                                              analysis.cybersecurityAnalysisError ||
                                              "None"
                                            }
                                            placement="top"
                                            arrow
                                          >
                                            <Typography
                                              variant="body2"
                                              sx={{
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                maxWidth: "22vw",
                                              }}
                                            >
                                              Error:{" "}
                                              {analysis.cybersecurityAnalysisError ||
                                                "None"}
                                            </Typography>
                                          </Tooltip>
                                        </Box>
                                        <Typography variant="body2">
                                          Time:{" "}
                                          {analysis.cybersecurityAnalysisTime ||
                                            "N/A"}
                                        </Typography>
                                      </AccordionDetails>
                                    </Accordion>
                                  )
                                )
                              ) : (
                                <Typography>No Analysis</Typography>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 20]}
                      component="div"
                      count={runDetails.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableContainer>
                </Box>
              </Box>
            </Grid>
          </Grid>
        )}
      </Paper>
    </Paper>
  );
};

export default ProjectBrief;
